import { DataObject } from 'src/models/DataObject'

export class Favouritable extends DataObject {
  toggleFavourited = async (queryParams?: Record<string, string>) => {
    return await this.post('toggle_favourite', undefined, true, undefined, queryParams)
  }
}
